<template>
  <div class="drawer" style="height: calc(100vh - 60px)">
    <div v-if="!activeSearchType && !isRadishDetail" class="drawer-alert">
      <div style="text-align:right"><peixun type="19" style="display:inline-block"></peixun></div>
      <div class="drawer-alert-title"><h4>快速搜索主页</h4></div>
      <p class="alert-content">
        提示：人选搜索可用姓名 或者 姓名+职能模块的形式（拼音搜索每个字用空格分开）<br>
        示例 【张清峰】 或者 【张清峰 空格 职能模块/职能模块关键词】
      </p>
    </div>
    <div v-if="!activeSearchType && !isRadishDetail" class="drawer-search-box">
      <div v-show="showHistorySearchType" class="drawer-meng" @click="hiddenCover"></div>
      <InputSearch
        :show-history-search-type="showHistorySearchType"
        search-label="人选（可以拼音搜索）"
        search-type="人选"
        placeholder="请输入关键词，多个关键词之间请用空格空开"
        @showHistory="showHistory"
        @doSearch="search"
      >
      </InputSearch>
      <InputSearch
        v-for="item in searchItems"
        :key="item.label"
        :show-history-search-type="showHistorySearchType"
        :search-label="item.label"
        :search-type="item.value"
        :placeholder="item.placeholder"
        @showHistory="showHistory"
        @doSearch="search"
      >
        <template slot="defaultItems">
          <div v-if="item.label === '公司'">
            <span
              v-for="v in homePageShowDefaultCompany"
              :key="v"
              class="link-item"
              @click="search({ type: '公司', keywords: v })"
            >
              {{ v }}
            </span>
          </div>
          <div v-else-if="item.label === '项目'">
            <p
              v-for="v in followProject"
              :key="v._id"
              class="link-item"
              @click="search({ type: '项目', keywords: v.项目名称 })"
            >
              {{ `${v.客户公司 ? `${v.客户公司}-` : ''}${v.部门 ? `${v.部门}-` : ''}${v.项目名称}` }}
            </p>
          </div>
        </template>
      </InputSearch>
      <IndustrySalarySearch @doSearch="search"></IndustrySalarySearch>
    </div>
    <div v-else-if="!activeSearchType && isRadishDetail" class="drawer-radish-detail-search-box">
      <div v-show="showHistorySearchType" class="drawer-meng" @click="hiddenCover"></div>
      <div class="radish-detail-search">
        <!-- <InputSearch :show-history-search-type="showHistorySearchType"
                      :search-label="item.label"
                      :search-type="item.value"
                      :placeholder="item.placeholder"
                      @showHistory="showHistory"
                      @doSearch="search">
        </InputSearch> -->
        <CommonSearch
          search-label="项目"
          :show-history-dialog="showHistorySearchType === 'commonsearch1'"
          @showHistory="showHistory('commonsearch1')"
          @doSearch="search"
          @goBack="goBack"
          @changeSearchType="changeSearchType"
        >
        </CommonSearch>
        <div class="default-project">
          <p>您要找的是不是以下项目：</p>
          <p
            v-for="project in defaultProject"
            :key="project._id"
            class="link-item"
            @click="search({ type: '项目', keywords: project.项目名称 })"
          >
            {{
              `${project.客户公司 ? `${project.客户公司}-` : ''}${project.部门 ? `${project.部门}-` : ''}${
                project.项目名称
              }`
            }}
          </p>
        </div>
      </div>
      <div class="radish-detail-search">
        <!-- <InputSearch v-for="item in searchItems"
                    :key="item.label"
                    :show-history-search-type="showHistorySearchType"
                    :search-label="item.label"
                    :search-type="item.value"
                    :placeholder="item.placeholder"
                    @showHistory="showHistory"
                    @doSearch="search">
        </InputSearch> -->
        <CommonSearch
          search-label="公司"
          :show-history-dialog="showHistorySearchType === 'commonsearch2'"
          @showHistory="showHistory('commonsearch2')"
          @doSearch="search"
          @goBack="goBack"
          @changeSearchType="changeSearchType"
        >
        </CommonSearch>
        <div class="default-company">
          <p>您要找的是不是以下公司：</p>
          <p
            v-for="company in defaultCompany"
            :key="company"
            class="link-item"
            @click="search({ type: '公司', keywords: company })"
          >
            {{ `${company}` }}
          </p>
        </div>
      </div>
    </div>
    <div v-else>
      <RadishSearchComponent
        v-if="activeSearchType === searchLabel2Value['人选']"
        ref="RadishSearchComponent"
        @searchTypeChange="changeSearchType"
        @goBack="goBack"
      ></RadishSearchComponent>
      <RepositorySearchComponent
        v-else-if="activeSearchType === searchLabel2Value['资源库']"
        ref="RepositorySearchComponent"
        @searchTypeChange="changeSearchType"
        @goBack="goBack"
      ></RepositorySearchComponent>
      <SalaryComponent
        v-else-if="activeSearchType === searchLabel2Value['薪酬']"
        ref="SalaryComponent"
        @searchTypeChange="changeSearchType"
        @goBack="goBack"
      ></SalaryComponent>
      <IndustrySalaryComponent
        v-else-if="activeSearchType === searchLabel2Value['行业薪酬']"
        ref="IndustrySalaryComponent"
        @searchTypeChange="changeSearchType"
        @goBack="goBack"
      ></IndustrySalaryComponent>
      <CompanyComponent
        v-else-if="activeSearchType === searchLabel2Value['公司']"
        ref="CompanyComponent"
        @searchTypeChange="changeSearchType"
        @drawerLoad="v => search(v)"
        @goBack="goBack"
      ></CompanyComponent>
      <ProjectComponent
        v-else-if="activeSearchType === searchLabel2Value['项目']"
        ref="ProjectComponent"
        @searchTypeChange="changeSearchType"
        @drawerLoad="v => search(v)"
        @goBack="goBack"
        @changeSearch="search"
      ></ProjectComponent>
    </div>
  </div>
</template>
<script>
import IndustrySalarySearch from './searchBar/IndustrySalary'
// import InputSearch from './searchBar/InputSearch'
import InputSearch from './searchBar/NewInputSearch'
import CommonSearch from './searchBar/CommonSearch'
import RadishSearchComponent from './childComponents/radish'
import RepositorySearchComponent from './childComponents/repository'
import SalaryComponent from './childComponents/salary'
import IndustrySalaryComponent from './childComponents/industrySalary'
import CompanyComponent from './childComponents/company'
import ProjectComponent from './childComponents/project'

import { searchLabel2Value, searchPlaceHolder } from './constant/utils'

const searchComponentMap = {
  人选: 'RadishSearchComponent',
  公司: 'CompanyComponent',
  项目: 'ProjectComponent',
  文件: 'RepositorySearchComponent',
  薪酬: 'SalaryComponent',
  行业薪酬: 'IndustrySalaryComponent',
}
export default {
  components: {
    InputSearch,
    IndustrySalarySearch,
    RadishSearchComponent,
    RepositorySearchComponent,
    SalaryComponent,
    IndustrySalaryComponent,
    CompanyComponent,
    CommonSearch,
    ProjectComponent,
  },
  data: function() {
    const searchTypeArr = ['公司', '项目', '资源库', '薪酬']
    const searchItems = searchTypeArr.map(type => ({
      label: type,
      value: searchLabel2Value[type],
      placeholder: searchPlaceHolder[type],
    }))
    return {
      isShowCover: false,
      searchLabel2Value: searchLabel2Value,
      searchPlaceHolder: searchPlaceHolder,
      showHistorySearchType: '',
      searchItems: searchItems,
      activeSearchType: '',
      isRadishDetail: false,
      defaultProject: [],
      defaultCompany: [],
      followProject: [],
      firstClick: true,
    }
  },
  computed: {
    homePageShowDefaultCompany() {
      return this.defaultCompany.slice(0, 8)
    },
  },
  methods: {
    init() {
      this.activeSearchType = null
      this.defaultProject = []
      this.defaultCompany = []
      this.followProject = []
      // if (this.firstClick) {
      //   const url = window.location.href
      //   this.isRadishDetail = url.includes('radish-detail-blank')
      //   if (this.isRadishDetail) this.getDefaultData()
      //   else this.homePageGetDefaultData()
      // } else {
      //   this.isRadishDetail = false
      //   this.homePageGetDefaultData()
      // }
      this.isRadishDetail = false
      this.homePageGetDefaultData()
    },
    goBack() {
      this.activeSearchType = null
      this.defaultProject = []
      this.defaultCompany = []
      this.followProject = []
      this.homePageGetDefaultData()
    },
    async getDefaultData() {
      this.firstClick = false
      const account = app.user.account
      const arr = window.location.href.split('/')
      const rid = arr[arr.length - 1]
      const projectRes = await app.service('misc').defaultSearchProject({ account, rid })
      if (projectRes.status === 'success') this.defaultProject = projectRes.data
      else this.$message.error(projectRes.msg)
      const companyRes = await app.service('misc').defaultSearchCompany({ account })
      if (companyRes.status === 'success') this.defaultCompany = companyRes.data
      else this.$message.error(companyRes.msg)
    },
    async homePageGetDefaultData() {
      const account = app.user.account
      const companyRes = await app.service('misc').defaultSearchCompany({ account })
      if (companyRes.status === 'success') this.defaultCompany = companyRes.data
      else this.$message.error(companyRes.msg)
      const followProjectRes = await app
        .service('project')
        .list({ query: {}, page: 1, limit: 3, sort: { 优先级: -1, createdAt: -1 }, isPined: true })
      if (followProjectRes.status === 'success') this.followProject = followProjectRes.data
      else this.$message.error(followProjectRes.msg)
    },
    showHistory(type) {
      this.showHistorySearchType = type
    },
    hiddenCover() {
      this.showHistorySearchType = ''
    },
    async search({ type, keywords, result, searchFormer, id }) {
      await app.service('project').saveRecords({ type, path: type, page: '快速搜索', data: { 关键词: keywords } })
      this.activeSearchType = type
      app.root.$refs.ZnAlpha.isZnAlphaShow = false
      if (type === '行业薪酬') {
        this.$nextTick(_ => {
          this.$refs[searchComponentMap[type]] && this.$refs[searchComponentMap[type]].defaultSearch({ type, keywords })
        })
      } else {
        this.$nextTick(_ => {
          this.$refs[searchComponentMap[type]] &&
            this.$refs[searchComponentMap[type]].defaultSearch({ type, keywords, result, searchFormer, id })
        })
      }
    },
    changeSearchType(type) {
      this.activeSearchType = type
    },
  },
}
</script>
<style>
.new-drawer-form {
  width: 100%;
  padding: 10px 25px;
  box-sizing: border-box;
  border: 1px solid #eee;
}
.new-drawer-form .input-with-select {
  z-index: 1001;
}
</style>
<style scoped>
.drawer-radish-detail-search-box {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.radish-detail-search {
  height: 50%;
}
.default-project {
  padding: 10px;
}
.default-company {
  padding: 10px;
}
.link-item {
  margin-top: 5px;
  margin-bottom: 5px;
  color: #409eff;
  cursor: pointer;
}
.drawer-alert {
  padding: 30px 25px 20px;
  border-top: 1px solid #eee;
  border-bottom: 6px solid #f1f3f4;
}
.drawer-alert .alert-title {
  margin-bottom: 10px;
  font-size: 14px;
}
.drawer-alert i {
  margin-right: 4px;
}
.drawer-alert .alert-content {
  color: #bfbfbf;
  font-weight: 400;
  padding-bottom: 10px;
}
.drawer-alert-title {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}
.drawer-alert-title h4 {
  font-size: 20px;
  font-weight: 600;
  width: 125px;
  position: relative;
  z-index: 1;
  text-align: center;
}
.drawer-alert-title h4:after {
  content: '';
  display: block;
  position: absolute;
  width: 110%;
  height: 12px;
  top: 61%;
  left: -5%;
  background-color: #eaf6ff;
  z-index: -1;
}
</style>
